import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Modal,
  Stack,
  Divider,
  Dialog,
  IconButton,
  DialogContent
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";

interface OrganisationSuccessModalProps {
  open: boolean;
  onClose: () => void;
  onRedirect?: () => void;
}

const OrganisationSuccessModal: React.FC<OrganisationSuccessModalProps> = ({
  open,
  onClose,
  onRedirect
}) => {
  const [countdown, setCountdown] = React.useState(5);

  useEffect(() => {
    if (!open) return;

    setCountdown(5);
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          if (onRedirect) {
            onRedirect();
          } else {
            onClose();
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [open, onClose, onRedirect]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          borderRadius: "6px",
          width: 538,
        },
      }}
    >
      {/* Header */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={2}
        py={1}
      >
        <Typography fontSize="18px" fontWeight={700}>
          Organisation Register
        </Typography>

        <IconButton size="small" onClick={onClose}>
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>
      <Divider />
      {/* Content */}
      <DialogContent
        sx={{ display: "flex", gap: 2, py: 3, flexDirection: "column" }}
      >
        {/* Icon */}
        <CheckCircleIcon
            sx={{
              fontSize: 80,
              color: "#16A34A",
              filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.1))"
            }}
          />

        {/* Message */}
        <Typography
          sx={{
            fontSize: 24,
            fontWeight: 700,
            color: "#212121",
            whiteSpace: "nowrap"
          }}
        >
          Organisation Register Successfully
        </Typography>
        <Stack spacing={2} sx={{ textAlign: "left", mt: 3 }}>
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontSize: 16,
              color: "#212121",
              fontWeight: 400,
              lineHeight: 1.6,
              letterSpacing: "-0.3%"
            }}
          >
            Your page will be redirect automatically in {countdown} seconds. Please do not refresh the page
          </Typography>
        </Stack>
      </DialogContent>
      {/* Actions */}
      {/* <Box
        display="flex"
        justifyContent="center"
        gap={2}
        pb={3}
        width="100%"
        maxWidth={380}
        margin="0 auto"
      >
        {cancelText && (
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              borderRadius: "24px",
              px: 4,
              fontSize: "12px",
              textTransform: "none",
              borderColor: "#dcdcdc",
              color: "#4b4b4b",
              flex: confirmText ? 1 : undefined,
              width: confirmText ? "100%" : "100%",
            }}
          >
            {cancelText}
          </Button>
        )}

        {confirmText && (
          <Button
            variant="contained"
            onClick={onConfirm}
            sx={{
              borderRadius: "24px",
              fontSize: "12px",
              px: 4,
              py: 1,
              textTransform: "none",
              background: "#3a1673",
              "&:hover": {
                background: "#3a1673",
              },
              flex: cancelText ? 1 : undefined,
              width: cancelText ? "100%" : "100%",
            }}
          >
            {confirmText}
          </Button>
        )}
      </Box> */}
    </Dialog>
  );
};

export default OrganisationSuccessModal;
